<template>
  <div>

    <!-- 头部 -->
    <header class="common-header">
      <div class="left">
        <div>
          <el-select v-model="parameter.searchType" size="medium" style="width:110px;" class="rightBorderNone">
            <el-option label="SPU" :value="1" />
            <el-option label="商品名称" :value="2" />
          </el-select>
          <el-popover placement="bottom" width="400" trigger="click" v-if="parameter.searchType === 1" style="margin-right:10px">
            <el-input v-model="parameter.searchNameArrays" size="medium" placeholder="支持批量搜索" style="width:250px" clearable @change="getProductList" slot="reference">
              <el-button slot="append" icon="el-icon-search" @click="searchGetProductList"></el-button>
            </el-input>
            <el-input v-model="parameter.searchNameArrays" placeholder="支持批量搜索" size="medium" type="textarea" style="width:100%" clearable @change="getProductList" :rows="6"></el-input>
          </el-popover>
          <el-input v-model="parameter.searchNameArrays" size="medium" placeholder="输入商品名称" style="width:270px;margin-right:10px" clearable @change="getProductList" v-if="parameter.searchType === 2">
            <el-button slot="append" icon="el-icon-search" @click="getProductList"></el-button>
          </el-input>
          <el-select v-model="parameter.reviewType" size="medium" clearable placeholder="全部评论" style="width:100px;margin-right:10px" @change="getProductList">
            <el-option label="AI评论" :value="0" />
            <el-option label="真实评论" :value="1" />
          </el-select>
          <!-- <el-date-picker v-model="addDate" type="datetimerange" size="medium" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" @change="changeDatePicker" style="width:350px;margin-right:10px" /> -->
          <el-cascader placeholder="请选择品类" size="medium" :options="categoryOptions" :props="{ multiple: true, value: 'categoryId', label: 'name', children: 'childList', emitPath: false }" :show-all-levels="false" filterable collapse-tags clearable v-model="categoryValue" @change="selectCategory" style="width: 260px;margin-right:12px">
            <template slot-scope="{ node, data }">
              <span>{{ data.name }}</span>
              <span v-if="!node.isLeaf"> ({{ data.childList.length }}) </span>
            </template>
          </el-cascader>
          <el-select v-model="parameter.status" size="medium" clearable placeholder="产品状态" style="width:100px;margin-right:10px" @change="getProductList">
            <el-option label="在售" :value="1" />
            <el-option label="缺货" :value="4" />
            <el-option label="下架" :value="0" />
          </el-select>
          <el-button @click="exportProductModule(25)">导出</el-button>
          <el-button size="medium" type="primary" round @click="addCategory">添加评论</el-button>
        </div>
      </div>
    </header>

    <!-- 主体 -->
    <section class="common-section">
      <el-table :data="productData" v-loading="loading" height="100%" @selection-change="handleSelectionChange" >
        <el-table-column type="selection" :min-width="50" />
        <el-table-column label="商品信息" :min-width="400">
          <template slot-scope="{ row }">
            <el-popover placement="right" width="280" trigger="hover">
              <el-image :src="row.images" fit="cover" />
              <el-image slot="reference" :src="row.images" fit="cover" class="stock-img" />
            </el-popover>
            <div style="display: inline-block;margin-left: 10px; width: 80%;">
              <el-tooltip v-if="row.productName" class="item" effect="dark" :content="row.productName" placement="top-start">
                <div class="ellipsis">标题: {{ row.productName }}</div>
              </el-tooltip>
              <div v-if="row.fullCategoryName" class="ellipsis">品类: {{ row.fullCategoryName ? row.fullCategoryName : '-' }}</div>
              <div v-if="row.spuCode">SPU: {{ row.spuCode }}</div>
              <div v-if="row.skuCode">SKU: {{ row.skuCode }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="商品状态" :min-width="150">
          <div slot-scope="{ row }" class="status f-c-c" :style="{ border: row.status === 1 ? '1px solid #99C41C' : row.status === 0 ? '1px solid #f07a7a' : row.status === 4 ? '1px solid #ffd400' : '', textAlign: 'center' }">
            <div class="left" :style="{ background: row.status === 1  ? '#99C41C' : row.status === 0 ? '#f07a7a' : row.status === 4 ? '#ffd400' : '' }"></div>
            <div>{{ row.status == 1  ? '在售' : row.status == 0 ? '下架' : row.status == 4 ? "缺货" : "" }}</div>
          </div>
        </el-table-column>
        <el-table-column prop="reviewSort" label="评论排序" width="150" :align="'center'">
          <template slot-scope="{ row }">
            <div class="sort">
              <div v-if="!row.editing" class="edit f--c">
                <span :style="{ fontWeight: row.reviewType === 1 ? 'bold' : 'normal', alignItems: 'center' }">{{ row.reviewSort }}</span>
                <el-tooltip content="编辑" placement="right">
                  <i class="el-icon-edit-outline" @click="startEditing(row)"></i>
                </el-tooltip>
              </div>
              <div v-else class="input">
                <el-input v-model="row.tempSort" :min="0" class="editing-input"></el-input>
                <el-tooltip content="保存" placement="right">
                  <i class="el-icon-check" @click="saveEditing(row)"></i>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>




      <el-table-column prop="review" label="商品评论" width="600" header-align="center" :align="'center'"></el-table-column>

        <el-table-column prop="star" label="评分" width="170" header-align="center" :align="'center'">
          <template slot-scope="{ row }">
            <el-rate v-model="row.star" disabled text-color="#ff9900"> </el-rate>
          </template> 
        </el-table-column>


        <el-table-column prop="createDate" label="用户信息"  width="160">
          <template slot-scope="{ row }">
            <div>Name:{{ row.userName }}</div>
            <div>Email:{{ row.email }}</div>
          </template>
        </el-table-column>

        <el-table-column prop="createDate" label="评论日期" width="230">
          <template slot-scope="{ row }">
            <div>{{ moment(row.createDate).format('YYYY-MM-DD HH:mm:ss') }}</div>
          </template>
        </el-table-column>


        <el-table-column label="操作" width="150">
          <template slot-scope="{ row }">
            <el-button type="text" size="medium" @click="() => deleteReview(row.id)"  style="text-align: center;">删除</el-button>
            <!-- <el-button type="text" size="medium" @click="() => getProductReviewById(row.id)"  style="text-align: center;">回复</el-button> -->
          </template>
        </el-table-column>

      </el-table>
    </section>

    <!-- 页脚 -->
    <footer class="common-footer">
      <el-pagination background :current-page="parameter.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="parameter.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </footer>

    
      <!-- 添加评论 -->
    <el-dialog :title="`新增评论`" :visible.sync="categoryDialogVisible" width="50%" :before-close="closeCategoryDialog" class="addOrEdit">

      <el-select v-model="addParameter.searchType" disabled size="medium" style="width:110px;" class="rightBorderNone">
        <el-option label="SPU" :value="1" />
      </el-select>
      <el-input v-model="addParameter.spuCode" size="medium" placeholder="输入SPU" style="width:270px;margin-right:10px" clearable  v-if="addParameter.searchType === 1">
        <el-button slot="append" icon="el-icon-search" @click="getProductInfoBySpuCode"></el-button>
      </el-input>

      <div v-loading="addloading">
        <el-form ref="form" label-position="right" :model="form" label-width="90px">
          <div class="flex-container" style="margin-top: 20px; margin-left: 1.5%; display:inline-block; font-weight: bold;" >
            <span style="display:inline-block; margin-right: 0px;" >
              你现在是KakaClo服装批发网站的
              <span style="color: red;"> *</span>
            </span>
            <el-form-item label="" prop="role" :rules="[{ required: true, message: '请选择角色', trigger: 'blur' }]"   style="display:inline-block; margin-left: 10px;" class="custom-form-item">
              <el-select v-model="form.role" size="medium" style="width:90%;" class="rightBorderNone">
                <el-option label="dropshipping客户" :value="1" />
                <el-option label="批发顾客" :value="2" />
                <el-option label="零售顾客" :value="3" />
                <!-- 可以继续添加更多角色选项 -->
              </el-select>
            </el-form-item>
            <span style="display:inline-block;">
              请为
            </span>
          </div>

          <div class="flex-container" >
            <div class="flex-item"  style="width: 40%;  display:inline-block; font-weight: bold;">
              <el-form-item label="产品标题:" prop="productName">
                <span style="font-weight: 400; word-wrap: break-word;">{{ form.productName }}</span>
              </el-form-item>
            </div>
            <div class="flex-item" style="width: 40%; display: inline-block; margin-left: 10%; font-weight: bold;">
              <el-form-item label="产品网址:" prop="fullCategoryName">
                <!-- Assuming "fullCategoryName" is a URL -->
                <span style="font-weight: 400; word-wrap: break-word; max-width: 100%;">{{ form.fullCategoryName }}</span>
              </el-form-item>
            </div>

          </div>

          <div class="flex-container">
            <div class="flex-item" style="width: 40%; display: inline-block; font-weight: bold;">
              <el-form-item label="产品属性:" prop="productAttribute">
                <el-checkbox-group v-model="form.productAttribute" style="display: flex; flex-direction: column;" :min="3" :max="8">
                  <el-checkbox v-for="(attr, index) in productAttributes" :key="index" :label="attr" @change="handleCheckChange"/>
                  <!-- 新增属性按钮 -->
                  <el-button v-if="!inputVisible.productAttribute"  style="width: 100px; border: none; color: #99c41c; font-weight: bold;" size="small" @click="showInput('productAttribute')">自定义属性</el-button>
                  <!-- 动态显示的输入框 -->
                  <div style="display: inline-block">
                    <el-input v-if="inputVisible.productAttribute" v-model="newProductAttribute" @keyup.enter.native.prevent="handleAddAttribute('productAttribute')" clearable placeholder="请输入新属性"/>
                    <el-button v-if="inputVisible.productAttribute" type="primary" icon="el-icon-check" size="small" @click="handleAddAttribute('productAttribute')">确定</el-button>
                  </div>
                  
                </el-checkbox-group>
              </el-form-item>
            </div>


            <div class="flex-item" style="width: 40%; margin-left: 10.8%; display: inline-block; font-weight: bold;">
              <el-form-item label="产品关键词:" prop="productKeyword">
                <el-checkbox-group v-model="form.productKeyword" style="display: flex; flex-direction: column;" :min="1" :max="3">
                  <el-checkbox v-for="(attr, index) in productKeywords" :key="index" :label="attr" @change="handleCheckChange"/>
                  <!-- 新增关键词按钮 -->
                  <el-button v-if="!inputVisible.productKeyword"  style="width: 100px; border: none; color: #99c41c; font-weight: bold;" size="small" @click="showInput('productKeyword')">自定义关键词</el-button>
                  <!-- 动态显示的输入框 -->
                  <div style="display: inline-block">
                    <el-input v-if="inputVisible.productKeyword" v-model="newProductKeyword" @keyup.enter.native.prevent="handleAddAttribute('productKeyword')" clearable placeholder="请输入新关键词"/>
                    <el-button v-if="inputVisible.productKeyword" type="primary" icon="el-icon-check" size="small" @click="handleAddAttribute('productKeyword')">确定</el-button>
                  </div>
                  
                </el-checkbox-group>
              </el-form-item>
            </div>
          </div>

          <div class="flex-container" style=" font-weight: bold;">
            <el-form-item label="产品评分:" :rules="[{ required: true, message: '请输入评分', trigger: 'blur' }]" prop="star">
              <el-rate style="line-height: 55px;" v-model="form.star"  text-color="#ff9900"></el-rate>
            </el-form-item>

            <el-form-item label="" prop="review">
              <el-input type="textarea" :rows="8" v-model="form.review"></el-input>
            </el-form-item>
          </div>
          <div class="flex-container" style="margin-top: 20px; margin-left: 1.5%; display:inline-block; font-weight: bold;" >
            <span style="display:inline-block; margin-right: 0px;" >
              的产品用
              <span style="color: red;"> *</span>
            </span>
            <el-form-item label="" prop="tone"  style="display:inline-block; margin-left: 10px;" class="custom-form-item">
              <el-input  v-model="form.tone"  clearable placeholder="请输入语气"/>
            </el-form-item>
            <span style="display:inline-block; margin-left: 10px;">
              的语气撰写一句英文产品评论。
            </span>
          </div>
          <div class="flex-container" >
            <el-form-item label="要求:" prop="require"  style="display:block;  font-weight: bold;">
              <el-input  v-model="form.require"  clearable placeholder="请输入要求"/>
            </el-form-item>
          </div>
          <div class="flex-container">
            <el-form-item label="字数:"  :rules="[{ required: true, message: '请输入字数', trigger: 'blur' }]" prop="wordCount">
              <el-input-number style="display:inline-block;  font-weight: bold;" v-model="form.wordCount"  :min="1" :max="40" label="描述文字"></el-input-number>
              <!-- 将 span 样式改为 inline-block 并移至 el-form-item 内部 -->
              <span style="display:inline-block; font-weight: bold; margin-left: 10px;">
                个单词。
              </span>
            </el-form-item>
          </div>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="medium" style="border: none; color: #99c41c; font-weight: bold;" @click="getProductAiReviewByPrompt">AI生成评论</el-button>
        <el-button size="medium" @click="closeCategoryDialog">取 消</el-button>
        <el-button size="medium" type="primary" @click="addManuallyProductAiReview()">确 定</el-button>
      </span>
    </el-dialog>


    <!-- 回复评论 -->
    <el-dialog  :title="`回复`" :visible.sync="replyDialogVisible" width="50%" :before-close="closeReplyDialog" class="addOrEdit">

      <el-form ref="replyForm" label-position="right" :model="form" label-width="90px">
        <div class="flex-container" >
          <div class="flex-item"  style="width: 40%;  display:inline-block; font-weight: bold;">
            <el-form-item label="产品标题:" prop="productName">
              <span style="font-weight: 400;">{{ replyForm.productName }}</span>
            </el-form-item>
          </div>
          <div class="flex-item" style="width: 40%; display: inline-block; margin-left: 10%; font-weight: bold;">
            <el-form-item label="产品网址:" prop="productUrl">
              <span style="font-weight: 400;">{{ replyForm.fullCategoryName }}</span>
            </el-form-item>
          </div>
        </div>

        <div class="flex-container" style="margin-top: 20px;" >
          <div class="flex-item"  style="width: 40%;  display:inline-block; font-weight: bold;">
            <el-form-item label="用户名:" prop="userName">
              <span style="font-weight: 400;">{{ replyForm.userName }}</span>
            </el-form-item>
          </div>
          <div class="flex-item" style="width: 40%; display: inline-block; margin-left: 10%; font-weight: bold;">
            <el-form-item label="用户邮箱:" prop="email">
              <span style="font-weight: 400;">{{ replyForm.email }}</span>
            </el-form-item>
          </div>
        </div>


        <div class="flex-container" style=" font-weight: bold;">
          <el-form-item label="产品评论:" prop="star">
            <el-rate style="line-height: 55px;" v-model="replyForm.star" disabled text-color="#ff9900"></el-rate>
          </el-form-item>

          <el-form-item label="" prop="review">
            <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" v-model="replyForm.review"></el-input>
          </el-form-item>

          <el-form-item label="回复内容:" prop="reviewReply">
            <el-input type="textarea" maxlength="200" show-word-limit :autosize="{ minRows: 4, maxRows: 6}" v-model="replyForm.reviewReply"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="closeReplyDialog">取 消</el-button>
        <el-button size="medium" type="primary" @click="submitReply()">确 定</el-button>
      </span>
    </el-dialog>
    

  </div>
</template>

<script>
import moment from 'moment'
import _ from 'lodash'
import API from '@/api'
export default {
  props: {
    categoryOptions: {
      type: Array,
      default: () => []
    },
    virtualWarehouse: {
      type: Array,
      default: () => []
    },
    tabType: {
      type: Number,
      default: () => 1
    }
  },
  data() {
    let parameter = {
      searchNameArrays: undefined, // 搜索关键字
      status: undefined, // 上架状态：0.下架 1.上架
      categoryIds: undefined, // 品类id集合
      pageNumber: 1, // 当前页
      pageSize: 20, // 每日显示条数
      dateType: 3,
      searchType: 1
    }
    let addParameter = {
      spuCode: undefined, // spu
      searchType: 1
    }
    return {
      ids: [], // 表格复选框当前选中行的评论id数组
      hoverRow: null,
      confirmDialogVisible : false,
      form: {
        role: 1, // 将角色字段设置为批发客户的值
        productName: '',
        fullCategoryName: '',
        productAttribute: [],
        productKeyword: [],
        star: null,
        review: '',
        tone: '',
        require: '',
        wordCount: 1

      }, // 添加/编辑品类对话框中表单的绑定值

      replyForm:{

      },

      inputVisible: {
        productAttribute: false,
        productKeyword: false,
      },
      newProductAttribute: '',
      newProductKeyword: '',
      
      productAttributes: [], // 产品属性
      productKeywords: [], // 产品关键词



      moment: moment, // 处理日期插件
      addDate: undefined, // 筛选 - 日期选择器绑定的值
      loading: false,
      addloading:false,
      parameter: { ...parameter, tabType: this.tabType }, // 表格数据请求参数
      productData: [], // 表格数据源
      kkProductIds: [], // 表格复选框当前选中行的id数组
      total: 0, // 分页总数
      filterCategoryText: undefined, // 加入品类对话框 - 过滤搜索框绑定的值
      categoryDialogVisible: false, // 加入品类对话框 - 是否显示Dialog
      visible: false, // 列表字段配置弹框 - 是否显示Dialog
      checkAll: false, // 列表字段配置弹框 - 是否全选
      categoryValue: [],
      addParameter: addParameter,
      replyDialogVisible: false, // 回复对话框 - 是否显示Dialog
 // Adding addParameter to data()

    }
  },
  computed: {
    isLast() {
      return (data) => {
        return this.checkIsLast(data)
      }
    }
  },
  watch: {
    filterCategoryText(value) {
      this.$refs.categoryTree.filter(value)
    }
  },
  mounted() {
    if (this.$route.query.spuCode) {
      this.parameter.searchNameArrays = this.$route.query.spuCode
    }
    this.getProductList()
  },
  methods: {
    checkIsLast(data) {
      if (!data.childList) {
        return true
      } else {
        this.checkIsLast(data.childList)
      }
    },

    // 获取商品列表
    async getProductList(call = true) {
      try {
        this.loading = true
        if (call) this.resetPage()
        let newParameter = { ...this.parameter, tabType: this.tabType }
        newParameter.searchNameArrays = newParameter.searchNameArrays ? newParameter.searchNameArrays.split('\n') : undefined
        let { data } = await API.getProductReviewManageList(newParameter)
        this.total = data.total
        this.productData = data.list.map(item => ({
          ...item,
          children: [],
          hasChildren: true,
          newStatus: item.status
        }))
        this.loading = false
      } catch (error) {
        this.loading = false
        throw new Error(error.message)
      }
      this.$tableScrollTop()
    },

    
    // 获取商品评论信息
    async getProductInfoBySpuCode() {
      try {
        this.addloading = true;
        let { data, code, message } = await API.getProductInfoBySpuCode({spuCode:this.addParameter.spuCode});
        if (code === 10000) {
          if(data){
            this.$set(this.form, 'role', 1)
            this.$set(this.form, 'fullCategoryName', data.fullCategoryName)
            this.$set(this.form, 'productName', data.productName)

            this.productAttributes = data.productAttribute
            let productAttribute = _.cloneDeep(data.productAttribute)
            if (productAttribute.length >= 8) productAttribute.length = 8
            this.$set(this.form, 'productAttribute', productAttribute)

            this.productKeywords = data.productKeyword
            let productKeyword = _.cloneDeep(data.productKeyword)
            if (productKeyword.length >= 3) productKeyword.length = 3
            this.$set(this.form, 'productKeyword', productKeyword)
          }
          this.addloading = false;
          this.$message.success(message)
        } else {
          this.addloading = true;
          this.$message.error(message)
        }
      } catch (error) {
        this.addloading = true;
        console.error("Error fetching product info:", error);
      }
    },

    async updateCouponStatus(query) {
      let { code, message } = await API.updateCouponStatus(query)
      if (code === 10000) {
        this.getCouponsList(false)
        this.$message.success(message)
      } else {
        this.$message.error(message)
      }
    },

    async addManuallyProductAiReview(){
      let newParameter = { ...this.form, spuCode: this.addParameter.spuCode }

      let {code, message  } = await API.addManuallyProductAiReview(newParameter)
      if (code === 10000) {
        this.closeCategoryDialog()
        this.getProductList()
        this.$message.success(message)
      } else {
        this.$message.error(message)
      }
    },

    // 提交评论回复
    async submitReply() {
      if (!this.replyForm.reviewReply || !this.replyForm.id) {
        return;
      }
      let {code, message } = await API.updateProductReview(this.replyForm)
      if (code === 10000) {
        this.replyDialogVisible = false;
        this.$message.success(message)
      } else {
        this.$message.error(message)
      }
    },

    // 根据提示获取商品信息AI评论
    async getProductAiReviewByPrompt() {
      let newParameter = { ...this.form, spuCode: this.addParameter.spuCode }
      let { code, data,message  } = await API.getProductAiReviewByPrompt(newParameter)
      if (code === 10000) {
        if (data) {
          this.$set(this.form, 'review', data)
        }
        this.$message.success(message)
      } else {
        this.$message.error(message)
      }
      
    },
    
    // 搜索列表
    searchGetProductList() {
      this.productData = []
      this.getProductList()
    },
    resetPage() {
      this.parameter.pageNumber = 1
    },
    // 添加/编辑品类对话框关闭事件的回调
    closeCategoryDialog() {
      this.form = {wordCount:1}
      this.productAttributes = []
      this.productKeywords = []
      this.addParameter = {searchType:1}
      this.categoryDialogVisible = false
      this.addloading = false;
      this.getProductList();
    },

    //回复对话框关闭事件的回调
    closeReplyDialog() {
      this.replyForm = {}
      this.replyDialogVisible = false
    },
    

    // 获取品类列表
    async getCategoryList() {
      let { data } = await API.getCategoryList({ pageNumber: 1, pageSize: 1000 })
      if (data && data.list.length) {
        this.deletechildList(data.list)
        this.categoryOptions = data.list
      }
    },
    deletechildList(arr) {
      // 删除最后一级为空的childList字段
      arr.forEach((item) => {
        if (!item.childList.length) {
          delete item.childList
        } else {
          this.deletechildList(item.childList)
        }
      })
    },
        // 添加品类
    addCategory() {
      this.title = '添加'
      this.categoryDialogVisible = true
      //this.getPublicSelectData()
    },
    
     // 获取商品评论信息
     async getProductReviewById(idStr) {
      try {
        this.title = '回复'
        this.replyDialogVisible = true
        let { code, data, message } = await API.getProductReviewById({id:idStr});
        if (code === 10000) {
          this.replyForm = data;
        } else {
          this.$message.error(message)
        }
      } catch (error) {
        console.error("Error fetching product info:", error);
      }
    },

    // 筛选 - 商品品类级联选择器选中值发生变化时的回调
    selectCategory(value) {
      if (!value.length) {
        this.parameter.categoryIds = undefined
      } else {
        this.parameter.categoryIds = value
      }
      this.getProductList()
    },

    // 当表格复选框选择项发生变化时会触发该事件
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id)
    },

    // 每页显示条数改变时的回调
    handleSizeChange(value) {
      this.parameter.pageSize = value
      this.getProductList(false)
    },

    // 当前页发生改变时触发的回调
    handleCurrentChange(value) {
      this.parameter.pageNumber = value
      this.getProductList(false)
    },

    handleCheckAllChange(val) {
      this.checkList = val ? this.columnTitles.map(item => item.value) : []
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.columnTitles.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnTitles.length;
    },
    save() {
      this.columns = _.cloneDeep(this.columnTitles).filter(item => this.checkList.includes(item.value))
      // 获取选中的值
      this.selected = _.cloneDeep(this.columns).map(item => item.title)
      this.parameter.showFields = [...this.checkList, 'productInfo', 'status', 'virtualWarehouseName', 'supplierLevel']
      this.getProductList(false)
      this.visible = false
      this.$forceUpdate()
    },


// 新写的
    showInput(type) {
      this.$set(this.inputVisible, type, true);
    },
    handleAddAttribute(type) {
      if (this.newProductAttribute.trim() || this.newProductKeyword.trim()) {
        if (type === 'productAttribute') {
          this.productAttributes.push(this.newProductAttribute.trim());
        } else if (type === 'productKeyword') {
          this.productKeywords.push(this.newProductKeyword.trim());
        }
        this.$set(this.inputVisible, type, false);
        this.newProductAttribute = '';
        this.newProductKeyword = '';
      }
    },
    // 保留原有的 change 事件处理逻辑，这里仅作占位
    handleCheckChange() {},
     // 删除评论
    deleteReview(idStr) {
      this.$confirm('是否确认删除？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let result = await API.deleteProductReview({id:idStr})
        if (result.code === 10000) {
          this.$message.success(result.message)
          this.getProductList()
        } else {
          this.$message.error(result.message)
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    startEditing(row) {
      this.$set(row, 'editing', true)
      this.$set(row, 'tempSort', row.reviewSort)
    },
    async saveEditing(row) {
      if (!row.id || !row.tempSort) {
        return;
      }
      let {code, message } = await API.updateProductReview({id:row.id, reviewSort:row.tempSort})
      if (code === 10000) {
        row.editing = false;
        this.getProductList()
        this.$message.success(message)
      } else {
        this.$message.error(message)
      }
    },

    // 导出产品专辑数据
    async exportProductModule(taskType) {
      let newParameter = { ...this.parameter, ids: this.ids }
      newParameter.searchNameArrays = newParameter.searchNameArrays ? (newParameter.searchNameArrays.includes(',') ? newParameter.searchNameArrays.split(',') : newParameter.searchNameArrays.split('\n')) : undefined
      delete newParameter.pageNumber
      delete newParameter.pageSize
      let taskTypeType = Object.prototype.toString.call(taskType).slice(8, -1)
      API.importExportFile({ fileType: 2, taskType: taskTypeType === 'Number' ? taskType : 4, condition: JSON.stringify(newParameter) }).then(() => {
        this.$message.success('产品评论数据导出成功,请前往导入导出中心查看进度')
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.common-header {
  // display: flex;
  width: 100%;
  height: 50px;
  align-items: center;
  .left {
    .el-input {
      width: 320px;
      .el-select {
        width: 100px;
      }
    }
    .rightBorderNone {
      margin-right: 0 !important;
      /deep/.el-input__inner {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right: none;
      }
    }
  }
}
.errorType {
  margin-top: 10px;
}

.common-section {
  height: calc(100vh - 294px);
  margin: 12px 0;
  .stock-img {
    width: 60px;
    height: 60px;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #f5f7fa;
    user-select: none;
    cursor: pointer;
  }

  .status {
    width: 80px;
    height: 36px;
    border-radius: 40px;
    .left {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      margin-right: 6px;
    }
  }
}

.common-footer {
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: flex-end;
}
/deep/.el-input-group__prepend {
  background-color: #fff !important;
}
/deep/.el-table__expand-icon {
  transform: rotate(0deg);
  > .el-icon-arrow-right::before {
    content: '\e6d9';
    border: 1px solid #ccc;
    padding: 1px;
  }
}
/deep/.el-table__expand-icon--expanded {
  .el-icon-arrow-right::before {
    content: '\e6d8';
  }
}
.errorTypeActive {
  color: #909399;
}
/deep/.el-table__row--level-0 {
  > td:nth-of-type(2) {
    .cell {
      display: flex;
      align-items: center;
    }
  }
}
// 新写样式
/deep/.custom-form-item .el-form-item__content {
  margin-left: unset !important;
}

.editing-input {
  width: 80px; /* 调整宽度 */
}
.sort {
  display: flex;
  justify-content: center;
  align-items: center;
  .edit {
    .el-icon-edit-outline {
      display: none;
    }
  }
  .edit:hover {
    .el-icon-edit-outline {
      display: block;
    }
  }
}
</style>
